import { useTranslation } from 'react-i18next';
import type { ItemHealth } from '@/common/api/types/dashboard/health';
import type { ItemStatus } from '@/common/api/types/itemStatus';
import { DependencyIndicator } from '@/features/item-panel/components/tabs/dependencies/DependencyIndicator';
import { resolvePredecessorImpactState } from '@/features/item-panel/components/tabs/dependencies/lib/edgeImpact';
import type { DependencyRow } from '@/features/item-panel/components/tabs/dependencies/lib/types';

export const DependencyPredecessorCell = ({
  row,
  currentItemHealth,
  dependencyRulesV2,
  itemStatuses,
  anchorDate,
}: {
  row: DependencyRow;
  currentItemHealth: ItemHealth | undefined;
  dependencyRulesV2: boolean;
  itemStatuses: ItemStatus[];
  anchorDate: string | null | undefined;
}) => {
  const { t } = useTranslation();
  const state = resolvePredecessorImpactState(dependencyRulesV2, {
    row,
    currentItemHealth,
    itemStatuses,
    anchorStartDate: anchorDate,
  });

  if (state === 'error' || state === 'warning') {
    return (
      <DependencyIndicator
        state={state}
        label={
          state === 'error'
            ? t(($) => $.adaptivePlanner.itemPanel.dependenciesSection.blockedBadge)
            : t(($) => $.adaptivePlanner.itemPanel.dependenciesSection.atRiskBadge)
        }
        testId="predecessor-alert-badge"
      />
    );
  }

  if (state === 'neutral') {
    return (
      <DependencyIndicator
        state="neutral"
        label={t(($) => $.adaptivePlanner.itemPanel.dependenciesSection.noDatesBadge)}
        testId="predecessor-no-dates-badge"
      />
    );
  }

  return <DependencyIndicator state="none" />;
};
